import React from 'react';
import PropTypes from 'prop-types';
import * as Api from 'utils/api/api.js';
import {PopUp} from './PopUp.component';
import Comment from '../input/Comment.component';
import UserSearch from '../input/UserSearch.component'
import {TASK_ACTIONS} from 'utils/constants';
import {getTaskUserDescription} from 'utils/valueFormatter.function';
import translate from '../translations/translations.wrapper.jsx';
import {Button, ButtonType} from "components/common/Button.component";
import {Notification, NotificationType} from "components/common/Notification.component";
import {FormField} from "components/common/FormField.component";

//this is to make sure the tabbing stays inside the dialog
const TAB_INDEX = 1000;

export class SendForward extends PopUp {
    constructor(props) {
        super(props);
        this.recipientInput = React.createRef();
        this.ok = this.ok.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.focusFirst = this.focusFirst.bind(this);
        this.state = {
            comment: '',
            recipient: null,
            actionRunning: false,
            displayError: null,
            refresh: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    focusFirst() {
        this.setState({
            refresh: true
        });
    }

    ok() {
        const self = this;
        if (this.state.comment && this.state.recipient && this.state.recipient.value) {
            this.setState({actionRunning: true});

            const key = this.props.tasks[0].key;
            Api.forwardTask(key, this.state.comment, this.state.recipient.value, this.props.tasks[0].uid).then(function (response) {
                    let description = getTaskUserDescription(self.props.tasks[0]);
                    const withPlaceholder = self.props.translate("popUp.forward.toastMessage", description, self.state.recipient.label);
                    self.props.showNotification(withPlaceholder);
                    self.props.handledTaskCallback(key, self.props.navigate);
                    self.props.closeCallback();
                },
                function (error) {
                    self.setState({displayError: error});
                });
        }
    }

    buildContent() {

        const okEnabled = this.state.comment && this.state.recipient && !this.state.actionRunning;
        return (
            <div>
                <article className="modal-body ast_send_forward">
                    <FormField
                        id="recipient"
                        label={this.props.translate("popUp.forward.recipient")}
                        labelState={`(${this.props.translate("popUp.required")})`}
                    >
                        <UserSearch
                            translate={this.props.translate}
                            tabindex={TAB_INDEX}
                            refresh={this.state.refresh}
                            taskId={this.props.tasks[0].key}
                            ariaLabel={this.props.translate("popUp.forward.recipient")}
                            placeholder={this.props.translate("userSearch.placeholder")}
                            propagateValue={value => this.setState({
                                recipient: value,
                                refresh: false,
                                actionRunning: false,
                                displayError: null
                            })}
                            value={this.state.recipient}
                            releaseFocus={() => {
                                this.setState({refresh: false})
                            }}
                            menuPosition={"fixed"}
                            menuPortalTarget={document.body}
                        />
                    </FormField>
                    {this.state.displayError &&
                        <div className={"my-16"}>
                            <Notification type={NotificationType.ERROR}
                                          title={this.state.displayError?.errorTitle}
                                          description={this.state.displayError?.errorMessages}/>
                        </div>
                    }

                    <Comment id="comment"
                             inputHint={this.props.translate("popUp.forward.commentHint")}
                             translate={this.props.translate}
                             tabIndex={TAB_INDEX + 1}
                             propagateValue={value => this.setState({comment: value, refresh: false})}
                             value={this.state.comment}
                             label={this.props.translate("popUp.forward.commentLabel")}
                             labelState={`(${this.props.translate("popUp.required")})`}
                    />
                </article>
                <div className="modal-footer">
                    {this.props.isCurrentTaskHandled ?
                        <div className="d-flex gap-8 float-left">
                            <Button type={ButtonType.PRIMARY}
                                    onClick={this.props.closeCallback}
                                    tabIndex={TAB_INDEX + 6}
                                    text={this.props.translate("popUp.reload")}
                            />
                        </div> :
                        <div className="d-flex gap-8 float-right">
                            <Button type={ButtonType.PRIMARY}
                                    onClick={this.ok}
                                    tabIndex={TAB_INDEX + 2}
                                    disabled={!okEnabled}
                                    text={this.props.translate("popUp.ok")}
                            />
                            <Button type={ButtonType.SECONDARY}
                                    onClick={this.props.closeCallback}
                                    tabIndex={TAB_INDEX + 3}
                                    onBlur={this.focusFirst}
                                    text={this.props.translate("popUp.cancel")}
                            />
                        </div>
                    }
                </div>
            </div>

        );
    }

    getType() {
        return TASK_ACTIONS.FORWARD;
    }

}

SendForward.propTypes = {
    tasks: PropTypes.array, // selected tasks
    closeCallback: PropTypes.func, //callback for closing the popup
    translate: PropTypes.func, // to translate texts
    showNotification: PropTypes.func, // to show transient notification

};
const withTranslations = translate(SendForward);
export default withTranslations;
